import styled from '@emotion/styled';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Step1 from './Step1';
import Step10 from './Step10';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import WarrantyDocuments from './document-steps/07-documents';
import WarrantyPhotos from './document-steps/08-photos';
import WarrantyShingles from './document-steps/09-shingles';
import ClaimsLanding from './landing';
import { setFormData, setStep, getWarrantyDetails } from './redux/action';

const Container = styled.div`
  margin: 0 auto;
  max-width: 35rem;
  width: 100%;

  .radioContainer {
    border: 1px solid #6d6d6d;
    margin-bottom: 1rem;
    max-width: 35rem;
    min-width: 48%;
    padding: 1rem;
  }

  .oc-cta-button {
    width: 100%;
    margin-top: 1rem;

    &:disabled {
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;

      &:before {
        transition: none;
      }
    }
  }

  .backContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    p {
      font-size: 12px;
      margin-top: 1px;
    }
  }

  .twoFields {
    display: flex;
    justify-content: space-between;

    fieldset {
      width: 100%;
    }
  }

  .editBtn,
  .editBtn2 {
    margin-top: 20px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
  }

  .editBtn2 {
    cursor: default;
  }

  .inputWrap {
    width: 100%;
    padding: 0.6em 0;
  }

  .mt10 {
    margin-top: 10px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .mr10 {
    margin-right: 10px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .centerText {
    text-align: center;
  }

  .infoText {
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-top: 10px;

    span {
      margin-right: 5px;
    }
  }

  p,
  li {
    font-size: 14px;
  }

  .hr {
    display: block !important;
    margin-top: 50px;
    margin-bottom: 30px;
    width: 100%;
  }

  .txtContainer {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .colorRed {
    color: #940420;
  }

  .claim-number {
    display: flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    background: #f8f8f8;
    padding: 0 10px;

    h4 {
      font-size: 14px;
    }
  }
`;
const WarrantyClaimsForm = ({ registrationNumber, registerData }) => {
  const step = useSelector(state => state.step) || 0;
  const dispatch = useDispatch();

  if (registrationNumber && step === 0) {
    dispatch(setStep(2));
    dispatch(
      setFormData({
        warrantyRegistrationNumber: registrationNumber,
        propertyClaimedBy: registerData?.propertyClaimedBy,
        showCurrentPropertyOwner: true,
        contractorEmail: registerData?.propertyClaimedBy === 'CONTRACTOR' ? registerData?.contractorEmail : '',
      })
    );

    if (registerData?.hasContractorInfo === 'true') {
      dispatch(
        setFormData({
          newContractorInfo: registerData?.newContractorInfo,
        })
      );
    }
    dispatch(getWarrantyDetails(true));
  }

  const formStep = stepNum =>
    ({
      0: <ClaimsLanding />,
      1: <Step1 />,
      2: <Step2 />,
      3: <Step3 />,
      4: <Step4 />,
      5: <Step5 />,
      6: <Step6 />,
      7: <WarrantyDocuments />,
      8: <WarrantyPhotos />,
      9: <WarrantyShingles />,
      10: <Step10 />,
    }[stepNum]);

  return <Container>{formStep(step)}</Container>;
};

export default WarrantyClaimsForm;
